import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/elzm';
import ELZMList from './ElzmList';


const ms2p = (state) => {
  return {
    ...state.rs_elzm,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ELZMList);